// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// reportWebVitals();





import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './i18n';

import App from './App';
import AuthProvider from './auth/AuthProvider';
import PlatformSettingsProvider from './branding/PlatformSettingsProvider';
import reportWebVitals from './reportWebVitals';
import { loadBrandFont } from './branding/brandFont';

loadBrandFont();

const root = ReactDOM.createRoot(
  document.getElementById('root'),
);

root.render(
  <React.StrictMode>
    <PlatformSettingsProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </PlatformSettingsProvider>
  </React.StrictMode>,
);

reportWebVitals();